import { addNarrativeRequest } from 'utilitys/narrative/narrativeTools';
import { WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryActivityPrediction } from 'api/queries/getActivityPrediction.query';

import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';

export const useFinishDateOverallSummaryProvider = ({
    widgetId,
    globalFilterData,
    localFilters,
    latestVersionId,
    componentKey,
    widgetViewMode,
}) => {
    const { isGenerativeAi, reportId } = usePinboardWidgetWrapperContext();
    const source = WidgetViewModeUtils.isReportOrPinboardView(widgetViewMode) ? localFilters : { ...globalFilterData };
    const isInPinboard = Boolean(widgetId);

    return {
        ui: {
            state: getState({ source }),
            pills: useGetPills(source, widgetId, latestVersionId),
            isInPinboard,
        },
        api: {
            getActivityPrediction: {
                instance: useQueryActivityPrediction(
                    getActivityPredictionPayload({
                        latestVersionId,
                        source,
                        isGenerativeAi,
                        componentKey,
                        widgetId,
                        reportId,
                    }),
                ),
                payload: getActivityPredictionPayload({
                    latestVersionId,
                    source,
                    isGenerativeAi,
                    componentKey,
                    widgetId,
                    reportId,
                }),
            },
        },
    };
};

const getActivityPredictionPayload = ({
    latestVersionId,
    source,
    isGenerativeAi,
    componentKey,
    widgetId,
    reportId,
}) => {
    return {
        versionId: latestVersionId,
        hashCode: source?.milestoneFragnet,
        ...addNarrativeRequest(isGenerativeAi, componentKey, widgetId, reportId),
    };
};

const getState = ({ source }) => {
    return {
        //global
        milestoneFragnet: source?.milestoneFragnet,
    };
};

const useGetPills = (source, widgetId, latestVersionId) => {
    const pillsData = {
        milestoneFragnet: source?.milestoneFragnet,
    };

    const { pillsList: pills } = useGlobalFiltersHook({
        widgetId,
        latestVersionId,
        source: pillsData,
    });

    return pills;
};
